module.exports = __webpack_public_path__ + "static/media/video03.2210e9f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/video03.mp4
// module id = Kzhn
// module chunks = 18